import React from 'react';
import {Link} from 'react-router-dom'

function BlogItem(props) {

    return (
        <div className={props.cols ? props.cols : 'col-md-6 col-lg-4'}>
            <div className="blog-item">
                
                {
                    props.thumb ? (
                        <figure className="blog-thumb">
                            {/* <Link to={`${process.env.PUBLIC_URL + blogURL}`}> */}
                                <img src={process.env.REACT_APP_BASE_URL + props.thumb} alt={props.title} />
                            {/* </Link> */}
                        </figure>
                    ) : null
                }

                <div className="blog-content">
                    <Link to={'/blog'+ `/${props.alias}/${props.id}`} style={{color:"#000"}}>
                        <h2 className="h5">{props.title}</h2>
                        <p dangerouslySetInnerHTML={{__html: props.excerpt}}/>
                        <div className="blog-meta">
                        <p>نویسنده: {props.postBy}</p>
                        </div>
                    </Link>
                </div>

            </div>
        </div>
    );
}

export default BlogItem;
